import { PayUInput, PayUForm } from '@shared/components/payu';
import { Typography, FormInput, Label } from '@ui/components';
import { PaymentCard } from '@pages/cost-centers/components';
import { FieldValues, Control, Path } from 'react-hook-form';
import { PayURef } from '@shared/components/payu';
import { useTranslation } from 'react-i18next';
import { Card } from '@ui/components/icons';
import { cn } from '@ui/utils';

interface PaymentCardMethodProps<T extends FieldValues> {
  control: Control<T>;
  onClick?: () => void;
  className?: string;
  open?: boolean;
  payUID: string;
  payURef: PayURef;
}

export function PaymentCardMethod<T extends FieldValues>({
  control,
  onClick,
  open,
  payUID,
  className,
  payURef,
}: PaymentCardMethodProps<T>) {
  const { t } = useTranslation();

  return (
    <div
      className={cn('flex flex-col border border-border-default rounded-md', className)}
      onClick={!open ? onClick : undefined}
    >
      <PaymentCard
        subtitle={t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_SUBTITLE')}
        title={t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_TITLE')}
        className="border-none"
        icon={<Card />}
      />
      {open && (
        <div className="px-4 pb-4 grid grid-cols-6 gap-4 items-center">
          <Label className="col-span-2" htmlFor="firstName">
            <Typography variant="labelSmallBook" className="text-weak" element="label">
              {t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.FIRST_NAME')}
            </Typography>
          </Label>
          <div className="col-span-4">
            <FormInput
              placeholder={t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.FIRST_NAME')}
              name={'newCard.firstName' as Path<T>}
              formControl={control}
              size="small"
            />
          </div>

          <Label className="col-span-2" htmlFor="lastName">
            <Typography variant="labelSmallBook" className="text-weak" element="label">
              {t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.LAST_NAME')}
            </Typography>
          </Label>
          <div className="col-span-4">
            <FormInput
              placeholder={t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.LAST_NAME')}
              name={'newCard.lastName' as Path<T>}
              formControl={control}
              size="small"
            />
          </div>

          <PayUForm payUID={payUID} ref={payURef}>
            <Label className="col-span-2">
              <Typography variant="labelSmallBook" className="text-weak" element="label">
                {t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.CARD_NUMBER')}
              </Typography>
            </Label>
            <div className="col-span-4">
              <PayUInput
                placeholder={t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.CARD_NUMBER')}
                payUControlType="number"
                id="payu-card-number"
                inputSize="small"
                name="cardNumber"
              />
            </div>

            <Label className="col-span-2">
              <Typography variant="labelSmallBook" className="text-weak" element="label">
                {t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.EXPIRATION_DATE')}
              </Typography>
            </Label>
            <div className="col-span-4">
              <PayUInput
                placeholder={t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.EXPIRATION_DATE')}
                payUControlType="date"
                id="payu-card-date"
                inputSize="small"
                name="cardDate"
              />
            </div>

            <Label className="col-span-2">
              <Typography variant="labelSmallBook" className="text-weak" element="label">
                {t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.CVV')}
              </Typography>
            </Label>
            <div className="col-span-4">
              <PayUInput
                placeholder={t('COST_CENTER.ACCOUNT_TOP_UPS.PAYMENT_CARD_FORM.CVV')}
                payUControlType="cvv"
                id="payu-card-cvv"
                inputSize="small"
                name="cardCvv"
              />
            </div>
          </PayUForm>
        </div>
      )}
    </div>
  );
}
